import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Mask,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

const HelpSupport = ({ ...props }) => {
  return (
    <Svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_4356_321)">
        <Mask
          id="a"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={48}
          height={48}
        >
          <Path
            d="M39.676.964H8.329A7.837 7.837 0 00.492 8.801v31.347a7.837 7.837 0 007.837 7.837h31.347a7.837 7.837 0 007.837-7.837V8.801A7.837 7.837 0 0039.676.964z"
            fill="#fff"
          />
        </Mask>
        <G mask="url(#a)">
          <Path
            d="M39.676.964H8.329A7.837 7.837 0 00.492 8.801v31.347a7.837 7.837 0 007.837 7.837h31.347a7.837 7.837 0 007.837-7.837V8.801A7.837 7.837 0 0039.676.964z"
            fill="#F2F7FF"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.309 19.592a3.918 3.918 0 00-3.918 3.918v9.858a3.918 3.918 0 003.918 3.918h1.11l1.802 3.482a.784.784 0 001.392 0l1.803-3.482h9.712a3.918 3.918 0 003.918-3.918V23.51a3.918 3.918 0 00-3.918-3.918H9.309z"
            fill="url(#paint0_radial_4356_321)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.675 29.174a3.918 3.918 0 013.918 3.918v9.858a3.918 3.918 0 01-3.918 3.918h-1.11l-1.803 3.481a.784.784 0 01-1.392 0l-1.802-3.481h-9.712a3.918 3.918 0 01-3.919-3.919v-9.857a3.918 3.918 0 013.919-3.918h15.819z"
            fill="url(#paint1_radial_4356_321)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.512 22.808a1.66 1.66 0 100 3.32h13.101a1.66 1.66 0 100-3.32H10.512zm-.084 6.133a1.577 1.577 0 000 3.154h3.59a1.577 1.577 0 000-3.154h-3.59z"
            fill="#F2F7FF"
          />
          <Path
            d="M34.166 44.456a.569.569 0 01-.563-.576c0-.317.252-.575.563-.575 1.111 0 2.015-.925 2.015-2.063v-3.897c0-2.26-1.796-4.1-4.005-4.1-2.208 0-4.005 1.84-4.005 4.1v2.035a.569.569 0 01-.562.576.569.569 0 01-.562-.576v-2.035c0-2.895 2.3-5.25 5.13-5.25 2.828 0 5.129 2.355 5.129 5.25v3.897c0 1.772-1.409 3.214-3.14 3.214z"
            fill="#F2F7FF"
          />
          <Path
            d="M27.636 41.706h-.05c-.694 0-1.258-.577-1.258-1.288v-2.125c0-.712.564-1.288 1.259-1.288h.05c.694 0 1.258.576 1.258 1.288v2.125c0 .711-.564 1.288-1.259 1.288z"
            fill="#F2F7FF"
          />
          <Path
            d="M36.769 41.706h-.05c-.694 0-1.258-.577-1.258-1.288v-2.125c0-.712.564-1.288 1.259-1.288h.049c.695 0 1.259.576 1.259 1.288v2.125c0 .711-.564 1.288-1.259 1.288z"
            fill="#fff"
          />
          <Path
            d="M27.856 37.03c.016.08.024.165.024.25v2.075c0 .726-.574 1.314-1.283 1.314-.084 0-.166-.01-.245-.025a1.291 1.291 0 001.259 1.062c.709 0 1.283-.588 1.283-1.313v-2.075c0-.64-.446-1.171-1.038-1.288zM36.99 37.03c.015.08.023.165.023.25v2.075c0 .726-.574 1.314-1.283 1.314-.084 0-.166-.01-.246-.025a1.291 1.291 0 001.26 1.062c.709 0 1.283-.588 1.283-1.313v-2.075c0-.64-.447-1.171-1.038-1.288z"
            fill="#C7DCFF"
          />
          <Path
            d="M33.54 44.943c.73 0 1.32-.475 1.32-1.062 0-.587-.59-1.062-1.32-1.062-.73 0-1.321.475-1.321 1.062 0 .587.591 1.062 1.32 1.062z"
            fill="#fff"
          />
          <Path
            d="M34.124 42.93c.021.075.033.152.033.232 0 .587-.592 1.062-1.321 1.062-.21 0-.41-.04-.586-.111.132.475.658.83 1.288.83.73 0 1.322-.475 1.322-1.062 0-.417-.3-.777-.736-.951z"
            fill="#C7DCFF"
          />
        </G>
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_4356_321"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-20.7968 20.2452 -17.67525 -18.15683 25.304 20.88)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_4356_321"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(19.97446 19.56112 -18.18681 18.57111 21.737 30.58)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <ClipPath id="clip0_4356_321">
          <Path
            fill="#fff"
            transform="translate(.492)"
            d="M0 0H47.0204V48H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default HelpSupport
